import React from "react";

import { Grid } from "@mui/material";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

import {
  Footer,
  FooterBigTitle,
  FooterButton,
  FooterInner,
  FooterInput,
  FooterLowerSection,
  FooterRule,
  FooterText,
  FooterTitle,
  FooterUpperSection,
  SocialIconsBlack,
  FooterSectionSocial,
  FooterTextArea,
} from "../../styles/home/FooterStyles";

import logo from "../../assets/img/home/main/logo.png";
import {
  HeaderLogo,
  HeaderItemBlock,
  HeaderLogoText,
} from "../../styles/home/HeaderStyles";

const HomeFooter = () => {
  return (
    <>
      <Footer>
        <FooterLowerSection>
          {/* <FooterRule /> */}
          <FooterInner>
            <Grid container spacing={2}>
              <Grid item lg={4} md={4} xs={6} sm={6}>
                <FooterTitle>
                  <HeaderItemBlock>
                    <HeaderLogo src={logo} />
                    <HeaderLogoText style={{ color: "white" }}>
                      AGROPREVER
                    </HeaderLogoText>
                  </HeaderItemBlock>
                </FooterTitle>
                <FooterSectionSocial>
                  <SocialIconsBlack>
                    <FacebookIcon
                      style={{
                        fontSize: "1.3em",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  </SocialIconsBlack>
                  <SocialIconsBlack>
                    <InstagramIcon
                      style={{
                        fontSize: "1.3em",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  </SocialIconsBlack>
                  <SocialIconsBlack>
                    <TwitterIcon
                      style={{
                        fontSize: "1.3em",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  </SocialIconsBlack>
                </FooterSectionSocial>
              </Grid>
              <Grid item lg={2} md={2} xs={6} sm={4}>
                <FooterTitle>All Products</FooterTitle>
                <FooterText>Farm management</FooterText>
                <FooterText>Satelite Imagery</FooterText>
                <FooterText>Crop Monitoring</FooterText>
                <FooterText>Crop Plan Rotation</FooterText>
                <FooterText>Weather Monitoring</FooterText>
              </Grid>

              <Grid item lg={2} md={2} xs={6} sm={4}>
                <FooterTitle>Help & Support</FooterTitle>
                <FooterText>Contact Us</FooterText>
                <FooterText>Partnership</FooterText>
              </Grid>

              <Grid item lg={2} md={2} xs={6} sm={4}>
                <FooterTitle>Legal</FooterTitle>
                <FooterText>Terms & Conditions</FooterText>
                <FooterText>Privacy Policy</FooterText>
                <FooterText>Licenses (EULA)</FooterText>
              </Grid>
            </Grid>
          </FooterInner>
        </FooterLowerSection>
      </Footer>
    </>
  );
};

export default HomeFooter;
